import styled from 'styled-components';
import {Box} from '@material-ui/core';
import {getDirectionStyles} from '../../../../utils/ThemeUtils';

// To pull legends up
export const ChartWrapper = styled(Box)`
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
`;

export const OptionWrapper = styled(Box)`
    width: 100%;
    margin-top: ${p => p.theme.muiTheme.spacing(1)}px;

    & > * {
        margin-bottom: ${p => p.theme.muiTheme.spacing(3)}px !important;
    }
`;

export const ControlsWrapper = styled(Box)`
    width: 100%;
    display: flex;
    flex-direction: column;

    margin: ${p =>
        getDirectionStyles(p.theme.muiTheme.direction)(
            p.theme.muiTheme.spacing(0, 0, 0, 7.5),
            p.theme.muiTheme.spacing(0, 7.5, 0, 0)
        )};

    ${p => p.theme.muiTheme.breakpoints.up('fmd')} {
        flex-direction: row;
        width: inherit;
        margin-left: 0;
    }
`;

export const SelectWrapper = styled(Box)`
    display: flex;
    width: 100%;

    ${p => p.theme.muiTheme.breakpoints.up('fmd')} {
        width: 230px;
    }
`;

export const VersionSelectWrapper = styled.div`
    display: flex;
    width: 140px;

    & [class*='MuiInputBase'] {
        height: 32px;
    }
`;

export const IconWrapper = styled(Box)`
    display: flex;
    align-items: center;

    margin: ${p =>
        getDirectionStyles(p.theme.muiTheme.direction)(
            p.theme.muiTheme.spacing(0, 1, 0, 5),
            p.theme.muiTheme.spacing(0, 5, 0, 1)
        )};

    ${p => p.theme.muiTheme.breakpoints.up('fmd')} {
        margin: ${p =>
            getDirectionStyles(p.theme.muiTheme.direction)(
                p.theme.muiTheme.spacing(0, 1, 0, 1),
                p.theme.muiTheme.spacing(0, 1, 0, 1)
            )};
    }
`;

export const Spacer = styled(Box)`
    width: ${p => p.theme.muiTheme.spacing(1)}px;
`;
